import React from "react";
import { Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

const NoRecordFound = ({
  message = "No records found",
  onRetry,
  showRetry = true,
  className = "",
  style,
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center p-8 text-center ${className}`}
      style={{
        minHeight: "200px",
        color: "#8c8c8c",
        ...style,
      }}
    >
      <div className="text-4xl mb-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-16 h-16 text-gray-300"
        >
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        </svg>
      </div>
      <h3 className="text-xl font-medium text-gray-500 mb-2">{message}</h3>
      {showRetry && onRetry && (
        <Button
          type="default"
          icon={<ReloadOutlined />}
          onClick={onRetry}
          className="mt-2 !bg-primary !text-white h-10 w-32 hover:!border-none hover:!bg-primary"
        >
          Try Again
        </Button>
      )}
    </div>
  );
};

export default NoRecordFound;
